import AxiosConfig from '../../../config/AxiosConfig';

const useTrackingLink = () => {
  const getTrackingLink = async (data) => {
    try {
      const response = await AxiosConfig.create('post', `/orders/tracking`)
        .call(data)
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to retract order SLO:', err);
      throw new Error(`SLO Order retraction failed: ${err.message}`);
    }
  };

  return {
    getTrackingLink,
  };
};

export default useTrackingLink;
